import { generateUtilityClass, generateUtilityClasses } from "@suid/base";
export function getCheckboxUtilityClass(slot) {
    return generateUtilityClass("MuiCheckbox", slot);
}
const checkboxClasses = generateUtilityClasses("MuiCheckbox", [
    "root",
    "checked",
    "disabled",
    "indeterminate",
    "colorPrimary",
    "colorSecondary",
]);
export default checkboxClasses;
